import { useEffect } from "react";
import { Link } from "react-router-dom";

const SITE_URL = import.meta.env.VITE_SITE_URL || "https://example.com";

const articles = [
  {
    slug: "porte-claquee-que-faire",
    title: "Porte claquée : que faire en urgence ?",
    excerpt:
      "Vous venez de claquer votre porte et vos clés sont à l'intérieur ? Pas de panique. Voici les étapes à suivre pour gérer cette situation stressante à Créteil et dans le Val-de-Marne.",
    category: "Urgence",
    date: "15 mars 2026",
    readTime: "3 min",
    backlink: { url: "https://ouverture-de-porte-creteil.fr", label: "ouverture-de-porte-creteil.fr" },
    img: "https://readdy.ai/api/search-image?query=person%20locked%20out%20of%20apartment%20door%20in%20French%20building%20hallway%2C%20stressed%20expression%2C%20modern%20residential%20building%20interior%2C%20warm%20lighting%2C%20realistic%20photo%2C%20clean%20white%20walls%2C%20urban%20France&width=600&height=400&seq=blog001&orientation=landscape",
  },
  {
    slug: "serrure-connectee-guide-2026",
    title: "Serrure connectée : le guide complet 2026",
    excerpt:
      "Nuki, Yale Connect, Somfy... Les serrures connectées révolutionnent la sécurité à domicile. Notre serrurier à Créteil vous explique tout pour bien choisir et installer votre serrure intelligente.",
    category: "Serrure connectée",
    date: "2 mars 2026",
    readTime: "5 min",
    backlink: { url: "https://mon-verrou.fr/", label: "mon-verrou.fr" },
    img: "https://readdy.ai/api/search-image?query=modern%20smart%20lock%20installed%20on%20white%20apartment%20door%2C%20smartphone%20app%20control%2C%20sleek%20minimalist%20design%2C%20close%20up%20product%20photo%2C%20clean%20background%2C%20high%20tech%20security%20device%2C%20professional%20photography&width=600&height=400&seq=blog002&orientation=landscape",
  },
  {
    slug: "choisir-serrure-3-points",
    title: "Comment choisir sa serrure 3 points ?",
    excerpt:
      "La serrure multipoints est le standard de sécurité pour les portes d'entrée. Certification A2P, marques recommandées, prix... Tout ce qu'il faut savoir avant de faire appel à un serrurier.",
    category: "Conseils",
    date: "18 février 2026",
    readTime: "4 min",
    backlink: { url: "https://serrurier-valdemarne.fr/", label: "serrurier-valdemarne.fr" },
    img: "https://readdy.ai/api/search-image?query=close%20up%20of%20high%20security%20multipoint%20door%20lock%20mechanism%2C%20professional%20locksmith%20tools%20nearby%2C%20metallic%20finish%2C%20clean%20white%20door%2C%20detailed%20product%20shot%2C%20French%20residential%20security%2C%20sharp%20focus&width=600&height=400&seq=blog003&orientation=landscape",
  },
  {
    slug: "urgence-serrurier-nuit",
    title: "Serrurier de nuit à Créteil : comment ça marche ?",
    excerpt:
      "Une urgence serrurerie ne prévient pas. Que faire à 2h du matin face à une porte bloquée ? Securycles vous explique son fonctionnement 24h/24 dans tout le Val-de-Marne.",
    category: "Urgence",
    date: "5 février 2026",
    readTime: "3 min",
    backlink: { url: "https://urgence-serrurier-puteaux.fr", label: "urgence-serrurier-puteaux.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20working%20at%20night%20on%20apartment%20door%20in%20Paris%20suburb%2C%20dark%20street%20lighting%2C%20professional%20uniform%2C%20emergency%20intervention%2C%20dramatic%20night%20scene%2C%20urban%20France%2C%20cinematic%20atmosphere&width=600&height=400&seq=blog004&orientation=landscape",
  },
  {
    slug: "prix-serrurier-creteil",
    title: "Prix d'un serrurier à Créteil en 2026",
    excerpt:
      "Combien coûte une ouverture de porte ? Un changement de serrure ? Securycles vous donne une grille tarifaire transparente pour éviter les mauvaises surprises lors d'une urgence serrurerie.",
    category: "Tarifs",
    date: "20 janvier 2026",
    readTime: "4 min",
    backlink: { url: "https://serrurier-bonneuil.fr", label: "serrurier-bonneuil.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20professional%20showing%20invoice%20to%20customer%20at%20apartment%20door%2C%20transparent%20pricing%2C%20friendly%20interaction%2C%20modern%20French%20residential%20building%2C%20natural%20daylight%2C%20trust%20and%20professionalism&width=600&height=400&seq=blog005&orientation=landscape",
  },
  {
    slug: "blindage-porte-apres-cambriolage",
    title: "Blindage de porte après un cambriolage : nos conseils",
    excerpt:
      "Victime d'un cambriolage dans le Val-de-Marne ? Le blindage de porte est la solution la plus efficace pour sécuriser durablement votre logement. Découvrez nos recommandations.",
    category: "Sécurité",
    date: "8 janvier 2026",
    readTime: "5 min",
    backlink: { url: "https://serrurier-maison-alfort.fr", label: "serrurier-maison-alfort.fr" },
    img: "https://readdy.ai/api/search-image?query=reinforced%20armored%20door%20installation%20in%20French%20apartment%20building%2C%20professional%20locksmith%20installing%20security%20door%20panel%2C%20modern%20tools%2C%20clean%20hallway%2C%20safety%20and%20protection%20concept%2C%20realistic%20photo&width=600&height=400&seq=blog006&orientation=landscape",
  },
  {
    slug: "changer-cylindre-serrure",
    title: "Changer le cylindre de sa serrure : quand et pourquoi ?",
    excerpt:
      "Déménagement, perte de clés, serrure forcée... Il existe de nombreuses raisons de changer le cylindre de sa serrure. Notre serrurier à Créteil vous explique la procédure et les cylindres recommandés.",
    category: "Conseils",
    date: "28 décembre 2025",
    readTime: "4 min",
    backlink: { url: "https://clevys.fr", label: "clevys.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20replacing%20door%20cylinder%20lock%20with%20new%20one%2C%20close%20up%20of%20hands%20installing%20security%20cylinder%2C%20professional%20tools%20on%20white%20background%2C%20modern%20apartment%20door%2C%20clean%20and%20precise%20work%2C%20French%20residential&width=600&height=400&seq=blog007&orientation=landscape",
  },
  {
    slug: "serrurerie-maison-alfort",
    title: "Serrurier à Maisons-Alfort : intervention rapide",
    excerpt:
      "Besoin d'un serrurier à Maisons-Alfort ? Securycles intervient en moins de 30 minutes pour toute urgence serrurerie : ouverture de porte, changement de serrure, blindage.",
    category: "Zones",
    date: "15 décembre 2025",
    readTime: "3 min",
    backlink: { url: "https://serrurier-neuilly.fr", label: "serrurier-neuilly.fr" },
    img: "https://readdy.ai/api/search-image?query=professional%20locksmith%20arriving%20quickly%20at%20residential%20building%20in%20French%20suburb%2C%20van%20parked%20outside%2C%20uniform%20with%20tools%2C%20daytime%20intervention%2C%20modern%20apartment%20complex%2C%20trust%20and%20speed%20concept&width=600&height=400&seq=blog008&orientation=landscape",
  },
  {
    slug: "vitrage-securite-fenetre",
    title: "Vitrage de sécurité : protéger ses fenêtres contre l'effraction",
    excerpt:
      "Les fenêtres sont souvent le point d'entrée des cambrioleurs. Vitrage feuilleté, film anti-effraction, volets renforcés... Découvrez comment sécuriser vos ouvertures dans le Val-de-Marne.",
    category: "Sécurité",
    date: "3 décembre 2025",
    readTime: "5 min",
    backlink: { url: "https://vitrier-la-queue-en-brie.fr", label: "vitrier-la-queue-en-brie.fr" },
    img: "https://readdy.ai/api/search-image?query=security%20window%20glass%20installation%20in%20French%20apartment%2C%20professional%20glazier%20installing%20reinforced%20laminated%20glass%2C%20modern%20residential%20building%2C%20safety%20concept%2C%20clean%20white%20walls%2C%20natural%20light%2C%20professional%20work&width=600&height=400&seq=blog009&orientation=landscape",
  },
  {
    slug: "serrure-bloquee-solutions",
    title: "Serrure bloquée : causes et solutions",
    excerpt:
      "Votre clé tourne dans le vide ou refuse de rentrer dans la serrure ? Une serrure bloquée peut avoir plusieurs origines. Voici comment diagnostiquer le problème et quand appeler un serrurier.",
    category: "Conseils",
    date: "20 novembre 2025",
    readTime: "4 min",
    backlink: { url: "https://vitrier-pontault-combault.fr", label: "vitrier-pontault-combault.fr" },
    img: "https://readdy.ai/api/search-image?query=broken%20door%20lock%20mechanism%20close%20up%2C%20key%20stuck%20in%20lock%2C%20frustrated%20person%20trying%20to%20open%20door%2C%20residential%20building%20hallway%2C%20warm%20indoor%20lighting%2C%20problem%20solving%20concept%2C%20realistic%20photo&width=600&height=400&seq=blog010&orientation=landscape",
  },
  {
    slug: "ouverture-voiture-creteil",
    title: "Ouverture de voiture à Créteil : clés enfermées, que faire ?",
    excerpt:
      "Clés enfermées dans votre voiture à Créteil ou dans le Val-de-Marne ? Securycles intervient rapidement pour ouvrir votre véhicule sans dommage. Découvrez notre service d'ouverture auto.",
    category: "Urgence",
    date: "8 novembre 2025",
    readTime: "3 min",
    backlink: { url: "https://ouverture-voiture.fr", label: "ouverture-voiture.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20opening%20car%20door%20with%20professional%20tools%2C%20keys%20locked%20inside%20vehicle%2C%20parking%20lot%20in%20French%20suburb%2C%20daytime%2C%20professional%20uniform%2C%20careful%20and%20precise%20intervention%2C%20no%20damage%20technique&width=600&height=400&seq=blog011&orientation=landscape",
  },
  {
    slug: "fuite-eau-urgence-creteil",
    title: "Fuite d'eau à Créteil : les bons réflexes en urgence",
    excerpt:
      "Une fuite d'eau peut rapidement causer des dégâts importants. Coupez l'eau, identifiez la source, contactez un professionnel... Voici les étapes à suivre en cas d'urgence plomberie dans le 94.",
    category: "Conseils",
    date: "25 octobre 2025",
    readTime: "4 min",
    backlink: { url: "https://recherche-de-fuite-creteil.fr", label: "recherche-de-fuite-creteil.fr" },
    img: "https://readdy.ai/api/search-image?query=water%20leak%20emergency%20in%20French%20apartment%2C%20plumber%20fixing%20pipe%20under%20sink%2C%20water%20damage%20on%20floor%2C%20urgent%20intervention%2C%20professional%20tools%2C%20realistic%20indoor%20photo%2C%20problem%20solving%2C%20residential%20building&width=600&height=400&seq=blog012&orientation=landscape",
  },
  {
    slug: "serrurier-boulogne-billancourt",
    title: "Serrurier à Boulogne-Billancourt : intervention express",
    excerpt:
      "Vous cherchez un serrurier fiable à Boulogne-Billancourt ? Securycles couvre toute la région parisienne avec des interventions rapides, des tarifs transparents et un service 24h/24.",
    category: "Zones",
    date: "12 octobre 2025",
    readTime: "3 min",
    backlink: { url: "https://urgence-serrurier-boulogne.fr", label: "urgence-serrurier-boulogne.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20professional%20in%20front%20of%20modern%20building%20in%20Boulogne%20Billancourt%20Paris%20suburb%2C%20professional%20van%2C%20uniform%2C%20tools%2C%20daytime%2C%20urban%20environment%2C%20trust%20and%20reliability%20concept%2C%20French%20city&width=600&height=400&seq=blog013&orientation=landscape",
  },
  {
    slug: "diagnostic-securite-domicile",
    title: "Diagnostic sécurité : évaluer les points faibles de votre logement",
    excerpt:
      "Avant d'investir dans de nouvelles serrures ou un blindage, un diagnostic sécurité permet d'identifier les vrais points faibles de votre logement. Securycles propose ce service dans tout le Val-de-Marne.",
    category: "Sécurité",
    date: "1 octobre 2025",
    readTime: "5 min",
    backlink: { url: "https://serrurier-oise.fr", label: "serrurier-oise.fr" },
    img: "https://readdy.ai/api/search-image?query=security%20expert%20inspecting%20apartment%20door%20and%20windows%2C%20professional%20assessment%2C%20clipboard%20and%20checklist%2C%20modern%20French%20residential%20building%2C%20natural%20light%2C%20trust%20and%20expertise%20concept%2C%20detailed%20inspection&width=600&height=400&seq=blog014&orientation=landscape",
  },
  {
    slug: "serrurier-issy-les-moulineaux",
    title: "Serrurier à Issy-les-Moulineaux : disponible 24h/24",
    excerpt:
      "Urgence serrurerie à Issy-les-Moulineaux ? Securycles intervient rapidement dans toute la zone pour ouverture de porte, changement de serrure et sécurisation de votre logement.",
    category: "Zones",
    date: "18 septembre 2025",
    readTime: "3 min",
    backlink: { url: "https://urgence-serrurier-issy.fr", label: "urgence-serrurier-issy.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20working%20on%20apartment%20door%20in%20Issy%20les%20Moulineaux%20Paris%20suburb%2C%20professional%20intervention%2C%20modern%20residential%20building%2C%20daytime%2C%20tools%20and%20equipment%2C%20reliable%20service%20concept%2C%20urban%20France&width=600&height=400&seq=blog015&orientation=landscape",
  },
  {
    slug: "plomberie-urgence-oise",
    title: "Plomberie d'urgence : quand appeler un professionnel ?",
    excerpt:
      "Canalisation bouchée, chauffe-eau en panne, robinet qui fuit... Certaines situations de plomberie nécessitent une intervention urgente. Découvrez les signes qui ne trompent pas.",
    category: "Conseils",
    date: "5 septembre 2025",
    readTime: "4 min",
    backlink: { url: "https://plombier-oise.fr", label: "plombier-oise.fr" },
    img: "https://readdy.ai/api/search-image?query=emergency%20plumber%20fixing%20burst%20pipe%20in%20French%20apartment%2C%20water%20everywhere%2C%20urgent%20intervention%2C%20professional%20tools%2C%20indoor%20residential%20setting%2C%20problem%20solving%2C%20realistic%20photo%2C%20professional%20uniform&width=600&height=400&seq=blog016&orientation=landscape",
  },
  {
    slug: "securite-locataire-proprietaire",
    title: "Sécurité locataire vs propriétaire : qui paie quoi ?",
    excerpt:
      "En cas de serrure cassée ou de porte forcée, qui doit payer les réparations ? Locataire ou propriétaire ? Securycles vous explique les règles légales et vos droits dans le Val-de-Marne.",
    category: "Conseils",
    date: "22 août 2025",
    readTime: "5 min",
    backlink: { url: "https://serrurier-bonneuil.fr", label: "serrurier-bonneuil.fr" },
    img: "https://readdy.ai/api/search-image?query=tenant%20and%20landlord%20discussing%20door%20security%20repair%2C%20contract%20and%20keys%20on%20table%2C%20professional%20meeting%20in%20French%20apartment%2C%20natural%20light%2C%20trust%20and%20legal%20concept%2C%20realistic%20photo%2C%20modern%20interior&width=600&height=400&seq=blog017&orientation=landscape",
  },
  {
    slug: "serrurier-charenton-le-pont",
    title: "Serrurier à Charenton-le-Pont : urgence et dépannage 24h/24",
    excerpt:
      "Besoin d'un serrurier à Charenton-le-Pont ? Securycles intervient en moins de 30 minutes pour toute urgence serrurerie : ouverture de porte claquée, changement de serrure, blindage de porte dans le Val-de-Marne.",
    category: "Zones",
    date: "10 août 2025",
    readTime: "3 min",
    backlink: { url: "https://serrurier-charenton.fr", label: "serrurier-charenton.fr" },
    img: "https://readdy.ai/api/search-image?query=professional%20locksmith%20arriving%20at%20modern%20residential%20building%20in%20Charenton%20le%20Pont%20French%20suburb%20near%20Paris%2C%20professional%20van%20parked%2C%20technician%20in%20uniform%20with%20tools%2C%20sunny%20daytime%2C%20trust%20and%20speed%20concept%2C%20urban%20Val%20de%20Marne&width=600&height=400&seq=blog018&orientation=landscape",
  },
  {
    slug: "serrurier-charenton-ouverture-porte",
    title: "Ouverture de porte à Charenton : serrurier agréé, tarif fixe",
    excerpt:
      "Porte claquée, clés perdues ou serrure bloquée à Charenton-le-Pont ? Securycles intervient en urgence avec un tarif fixe annoncé avant déplacement. Serrurier agréé, disponible 24h/24 dans le Val-de-Marne.",
    category: "Urgence",
    date: "5 avril 2026",
    readTime: "4 min",
    backlink: { url: "https://serrurier-charenton.fr", label: "serrurier-charenton.fr" },
    img: "https://readdy.ai/api/search-image?query=locksmith%20opening%20apartment%20door%20in%20Charenton%20le%20Pont%20suburb%20Paris%2C%20professional%20technician%20with%20tools%20at%20residential%20building%20entrance%2C%20golden%20hour%20lighting%2C%20modern%20French%20architecture%2C%20trust%20and%20expertise%2C%20urban%20Val%20de%20Marne&width=600&height=400&seq=blog019&orientation=landscape",
  },
  {
    slug: "artisan-serrurier-val-de-marne",
    title: "Artisan serrurier dans le Val-de-Marne : pourquoi choisir un vrai artisan ?",
    excerpt:
      "Face aux plateformes et aux grandes enseignes, l'artisan serrurier local reste la meilleure garantie de qualité, de transparence et de réactivité. Securycles vous explique pourquoi faire confiance à un artisan du 94.",
    category: "Conseils",
    date: "10 avril 2026",
    readTime: "5 min",
    backlink: { url: "https://atelier-de-lartisan.fr", label: "atelier-de-lartisan.fr" },
    img: "https://readdy.ai/api/search-image?query=skilled%20French%20artisan%20locksmith%20working%20carefully%20in%20his%20workshop%2C%20traditional%20tools%20and%20modern%20security%20equipment%2C%20warm%20workshop%20lighting%2C%20craftsmanship%20and%20expertise%2C%20professional%20portrait%2C%20Val%20de%20Marne%20France&width=600&height=400&seq=blog020&orientation=landscape",
  },
  {
    slug: "volet-roulant-urgence-val-de-marne",
    title: "Volet roulant bloqué en urgence : que faire dans le Val-de-Marne ?",
    excerpt:
      "Volet roulant coincé, lames cassées ou moteur en panne dans le Val-de-Marne ? Découvrez les bons réflexes à adopter et comment faire intervenir un professionnel rapidement pour sécuriser votre logement.",
    category: "Urgence",
    date: "14 avril 2026",
    readTime: "4 min",
    backlink: { url: "https://voleturgence.fr/", label: "voleturgence.fr" },
    img: "https://readdy.ai/api/search-image?query=broken%20roller%20shutter%20on%20French%20apartment%20window%2C%20technician%20repairing%20stuck%20rolling%20shutter%2C%20residential%20building%20facade%2C%20daytime%20urban%20France%2C%20professional%20repair%20intervention%2C%20safety%20and%20security%20concept&width=600&height=400&seq=blog021&orientation=landscape",
  },
];

const categoryColors: Record<string, string> = {
  Urgence: "bg-red-100 text-red-700",
  "Serrure connectée": "bg-[#FFB100]/15 text-[#8a6000]",
  Conseils: "bg-green-100 text-green-700",
  Tarifs: "bg-gray-100 text-gray-700",
  Sécurité: "bg-black text-white",
  Zones: "bg-[#FFB100]/20 text-[#7a5500]",
};

export default function BlogPage() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = "Blog Serrurerie Créteil — Conseils & Urgences | Securycles";
    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? "property" : "name";
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    setMeta("description", "Conseils pratiques, guides et actualités de votre serrurier à Créteil et dans tout le Val-de-Marne. Urgence serrurerie, serrure connectée, blindage de porte.");
    setMeta("keywords", "blog serrurerie, conseils serrurier Créteil, urgence serrurerie 94, serrure connectée guide");
    setMeta("robots", "index, follow");

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${SITE_URL}/blog`);

    setMeta("og:type", "website", true);
    setMeta("og:title", "Blog Serrurerie Créteil — Conseils & Urgences | Securycles", true);
    setMeta("og:description", "Conseils pratiques, guides et actualités de votre serrurier à Créteil et dans tout le Val-de-Marne.", true);
    setMeta("og:url", `${SITE_URL}/blog`, true);
    setMeta("og:locale", "fr_FR", true);
    setMeta("og:site_name", "Securycles", true);

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", "Blog Serrurerie Créteil — Conseils & Urgences | Securycles");
    setMeta("twitter:description", "Conseils pratiques, guides et actualités de votre serrurier à Créteil et dans tout le Val-de-Marne.");

    const schemaId = "schema-blog-page";
    let existing = document.getElementById(schemaId);
    if (existing) existing.remove();
    const script = document.createElement("script");
    script.id = schemaId;
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Blog Serrurerie Securycles",
      "description": "Conseils pratiques, guides et actualités de votre serrurier à Créteil et dans tout le Val-de-Marne.",
      "url": `${SITE_URL}/blog`,
      "publisher": {
        "@type": "LocalBusiness",
        "name": "Securycles",
        "url": SITE_URL,
        "telephone": "+33604026840",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Créteil",
          "postalCode": "94000",
          "addressRegion": "Val-de-Marne",
          "addressCountry": "FR"
        }
      },
      "blogPost": articles.map((a) => ({
        "@type": "BlogPosting",
        "headline": a.title,
        "description": a.excerpt,
        "url": `${SITE_URL}/blog/${a.slug}`,
        "datePublished": a.date,
        "image": a.img,
        "author": { "@type": "Organization", "name": "Securycles" },
        "publisher": { "@type": "Organization", "name": "Securycles" }
      }))
    });
    document.head.appendChild(script);

    return () => {
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  const featured = articles[0];
  const rest = articles.slice(1);

  return (
    <main className="min-h-screen bg-[#FAFAFA] pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="mb-12">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-500 text-sm hover:text-black transition-colors cursor-pointer mb-6"
          >
            <i className="ri-arrow-left-line"></i>
            Retour à l&apos;accueil
          </Link>
          <div
            className="h-2 w-24 rounded-full mb-6"
            style={{
              backgroundImage:
                "repeating-linear-gradient(90deg, #FFB100 0px, #FFB100 10px, #000000 10px, #000000 20px)",
            }}
          ></div>
          <h1 className="text-3xl md:text-5xl font-black text-black uppercase leading-tight mb-3">
            Blog Serrurerie
            <br />
            <span className="text-[#FFB100]">Conseils &amp; Urgences</span>
          </h1>
          <p className="text-gray-500 text-base max-w-xl">
            Conseils pratiques, guides et actualités de votre serrurier à Créteil et dans tout le Val-de-Marne.
          </p>
        </div>

        {/* Featured article */}
        <div className="mb-10">
          <div className="rounded-2xl overflow-hidden bg-white border border-gray-100 grid grid-cols-1 lg:grid-cols-2">
            <div className="h-56 lg:h-auto">
              <img
                src={featured.img}
                alt={featured.title}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 md:p-8 flex flex-col justify-center">
              <div className="flex items-center gap-2 mb-3">
                <span className={`text-xs font-bold px-2.5 py-1 rounded-full ${categoryColors[featured.category]}`}>
                  {featured.category}
                </span>
                <span className="text-gray-400 text-xs">{featured.date}</span>
                <span className="text-gray-400 text-xs">· {featured.readTime} de lecture</span>
              </div>
              <h2 className="text-xl md:text-2xl font-black text-black mb-3 leading-tight">
                {featured.title}
              </h2>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                {featured.excerpt}
              </p>
              <p className="text-xs text-gray-400 mb-5">
                Source utile :{" "}
                <a
                  href={`https://${featured.backlink.url.replace(/^https?:\/\//, "")}`}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-[#FFB100] hover:underline"
                >
                  {featured.backlink.label}
                </a>
              </p>
              <Link
                to={`/blog/${featured.slug}`}
                className="inline-flex items-center gap-2 bg-[#FFB100] text-black font-bold text-sm px-5 py-2.5 rounded-full hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap self-start"
              >
                Lire l&apos;article
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>

        {/* Articles grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {rest.map((article) => (
            <div
              key={article.slug}
              className="bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-[#FFB100]/40 hover:-translate-y-0.5 transition-all duration-200 group flex flex-col"
            >
              <Link to={`/blog/${article.slug}`} className="block h-44 overflow-hidden cursor-pointer">
                <img
                  src={article.img}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </Link>
              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 mb-2">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${categoryColors[article.category]}`}>
                    {article.category}
                  </span>
                  <span className="text-gray-400 text-xs">{article.readTime}</span>
                </div>
                <Link to={`/blog/${article.slug}`} className="cursor-pointer">
                  <h3 className="font-black text-black text-sm leading-tight mb-2 hover:text-[#FFB100] transition-colors">
                    {article.title}
                  </h3>
                </Link>
                <p className="text-gray-500 text-xs leading-relaxed line-clamp-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="mt-3 pt-3 border-t border-gray-50 flex items-center justify-between">
                  <Link
                    to={`/blog/${article.slug}`}
                    className="flex items-center gap-1 text-[#FFB100] text-xs font-bold cursor-pointer"
                  >
                    Lire <i className="ri-arrow-right-line"></i>
                  </Link>
                  <a
                    href={`https://${article.backlink.url.replace(/^https?:\/\//, "")}`}
                    target="_blank"
                    rel="nofollow noopener noreferrer"
                    className="text-gray-300 text-xs hover:text-gray-400 transition-colors truncate max-w-[120px]"
                    title={article.backlink.label}
                  >
                    {article.backlink.label}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 bg-black rounded-2xl p-8 md:p-10 text-center relative overflow-hidden">
          <div
            className="absolute inset-0 opacity-10"
            style={{
              backgroundImage:
                "repeating-linear-gradient(45deg, #FFB100 0px, #FFB100 4px, transparent 4px, transparent 40px)",
            }}
          ></div>
          <div className="relative">
            <p className="text-[#FFB100] text-xs font-black uppercase tracking-widest mb-3">Urgence serrurerie</p>
            <h2 className="text-2xl md:text-3xl font-black text-white uppercase mb-4">
              Besoin d&apos;un serrurier maintenant ?
            </h2>
            <a
              href="tel:0604026840"
              className="inline-flex items-center gap-2 bg-[#FFB100] text-black font-black text-base px-7 py-3.5 rounded-full hover:bg-yellow-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill"></i>
              06 04 02 68 40 — Disponible 24h/24
            </a>
          </div>
        </div>
      </div>
    </main>
  );
}
